export const fetchConfig = {
    batchSize: 20,
    threshold: 4
}
